import { computed, Directive, input, output } from '@angular/core';
import type { ValidationError } from '@angular/forms/signals';
import { toValidationErrorType } from '../utils/field-error';

/**
 * Field state that `[formField]` pushes into a Signal Forms custom control. The input names are
 * the `FormUiControl` contract, so the directive binds them automatically — never rename them.
 * The value itself (`value` / `checked` model) is declared by each control.
 */
@Directive()
export abstract class UiFieldControl {
  readonly touched = input(false);
  readonly dirty = input(false);
  readonly errors = input<readonly ValidationError[]>([]);
  readonly disabled = input(false);
  readonly required = input(false);
  readonly isErrorVisible = input(true);

  readonly touch = output<void>();

  protected readonly isErrorShown = computed(
    () => (this.touched() || this.dirty()) && this.errors().length > 0,
  );
  protected readonly error = computed(() =>
    this.isErrorShown() ? toValidationErrorType(this.errors()[0]) : null,
  );
}
